import { useQuery } from "@tanstack/react-query";
import { ListUsersQueryFilters, UseListUsersQueryOptions } from "./types";
import { getUsersService } from "./service";

export const listUsersQueryKey = ["user_admin"];

export function useListUsersQuery(
  filters?: ListUsersQueryFilters,
  options?: UseListUsersQueryOptions
) {
  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }
  const queryKey = listUsersQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getUsersService(filters),
    ...options,
  });
}
